import { render, staticRenderFns } from "./KidsHeightWeight.vue?vue&type=template&id=5ed4c166&scoped=true"
import script from "./KidsHeightWeight.vue?vue&type=script&lang=js"
export * from "./KidsHeightWeight.vue?vue&type=script&lang=js"
import style0 from "./KidsHeightWeight.vue?vue&type=style&index=0&id=5ed4c166&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4c166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed4c166')) {
      api.createRecord('5ed4c166', component.options)
    } else {
      api.reload('5ed4c166', component.options)
    }
    module.hot.accept("./KidsHeightWeight.vue?vue&type=template&id=5ed4c166&scoped=true", function () {
      api.rerender('5ed4c166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/KidsHeightWeight.vue"
export default component.exports